import { api } from '@api/index'
import AdminSidebar from '@components/admin/AdminSidebar'
import NoticePriorityChangeButton from '@components/admin/NoticePriorityChangeButton'
import BaseTable from '@components/shared/BaseTable'
import usePagenation from '@hooks/usePagenation'
import React from 'react'
import { useForm } from 'react-hook-form'
import { QueryFunctionContext, useQuery, useQueryClient } from 'react-query'
import 'twin.macro'
import uuid from 'react-uuid'
import { Link, useNavigate } from 'react-router-dom'

const rowSize = 8

const renderNoticeState = (startDateStr: string, endDateStr: string) => {
  const startDate = new Date(startDateStr)
  const currendDate = new Date()
  const endDate = new Date(endDateStr)

  if (currendDate < startDate) {
    return <span tw="text-yellow-600">예정</span>
  }
  if (startDate <= currendDate && currendDate <= endDate) {
    return <span tw="text-green-600">진행</span>
  }
  if (currendDate > endDate) {
    return <span tw="text-red-500">마감</span>
  }
}

const fetchNoticeList = ({ queryKey }: QueryFunctionContext) => {
  const [_, page] = queryKey
  return api.adminService.getNoticeList({
    size: rowSize,
    page: (page as number) - 1, //서버측 pageIndex는 0부터 시작
    sort: 'priority,desc',
  })
}

const AdminNoticeManagement = () => {
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  const {
    pagelist,
    currentPage,
    goBeforeSection,
    goNextSection,
    goNext,
    goBefore,
    setListRefIndex,
    setTotalPage,
  } = usePagenation(5)

  const {
    isLoading,
    error,
    data: { totalPages, content } = {} as NoticePagenationInfo,
  } = useQuery(['NoticeList', currentPage], fetchNoticeList, {
    refetchOnWindowFocus: false,
  })

  const handleUserListRowClick = (uuid: Number) => {
    navigate(`/admin/notice-management/${uuid}`)
  }

  return (
    <>
      <section tw="w-1200 flex gap-32">
        <AdminSidebar />
        <main tw="w-full ">
          <h1 tw="text-2xl border-b-2 font-bold pb-10 border-neutral-400">
            공지사항 관리
          </h1>
          <div tw="flex justify-end items-center gap-12 mt-20">
            <Link to={'/admin/notice-management/add'}>
              <button className="button base">추가</button>
            </Link>
          </div>
          <div tw="py-20">
            <BaseTable
              column={[
                ['제목', 5],
                ['시작일', 5],
                ['마감일', 5],
                ['상태', 6],
                ['순서 변경', 4],
              ]}
            >
              {content?.map(({ id, title, startDate, endDate }) => (
                <tr
                  onClick={() => handleUserListRowClick(Number(id))}
                  key={id}
                  tw="cursor-pointer hover:bg-neutral-200"
                >
                  <td>{title}</td>
                  <td>{startDate}</td>
                  <td>{endDate}</td>
                  <td>{renderNoticeState(startDate, endDate)}</td>
                  <td>
                    <NoticePriorityChangeButton
                      currentPageIdx={currentPage}
                      noticeId={Number(id)}
                      key={uuid()}
                    />
                  </td>
                </tr>
              ))}
            </BaseTable>
          </div>
          <div tw="w-full flex justify-center gap-8 mt-15">
            {' '}
            <button
              type="button"
              className="button base"
              onClick={goBeforeSection}
            >
              {'<<'}
            </button>
            <button type="button" className="button base" onClick={goBefore}>
              {'<'}
            </button>
            {pagelist.map((num, idx) => (
              <button
                type="button"
                className="button base"
                onClick={() => setListRefIndex(idx)}
                key={num}
              >
                {num}
              </button>
            ))}
            <button type="button" className="button base" onClick={goNext}>
              {'>'}
            </button>
            <button
              type="button"
              className="button base"
              onClick={goNextSection}
            >
              {'>>'}
            </button>
          </div>
        </main>
      </section>
    </>
  )
}

export default AdminNoticeManagement
